import { api } from '../../../api/common/instances';
import { pascalCase } from 'change-case';

const state = {
  dst: false,
  timeZoneId: '',
  alertBeep: '',
  language: '',
  theme: '',
  defaultTargetMonitoringSystemId: '',
  targetMonitoringSystemIds: [],
  username: '',
  name: '',
  alertConfirmTime: 0,
  // Added.by.KWShin.2023.10.26.
  role: '',
  // 사용자의 모니터링 대상에 Java Stack 시스템이 포함되어 있는지 여부.
  // 화면별 Java 관련 메뉴/트리 필터링에 사용.
  hasJavaStack: false,
};

const getters = {};

const mutations = {
  setDst(state, dst) {
    state.dst = dst;
  },
  setTimeZoneId(state, timeZoneId) {
    state.timeZoneId = timeZoneId;
  },
  setAlertBeep(state, alertBeep) {
    state.alertBeep = alertBeep;
  },
  setLanguage(state, language) {
    state.language = language;
  },
  setTheme(state, theme) {
    state.theme = theme;
  },
  setDefaultTargetMonitoringSystemId(state, defaultTargetMonitoringSystemId) {
    state.defaultTargetMonitoringSystemId = defaultTargetMonitoringSystemId;
  },
  setTargetMonitoringSystemIds(state, targetMonitoringSystemIds) {
    state.targetMonitoringSystemIds = targetMonitoringSystemIds;
  },
  setUsername(state, username) {
    state.username = username;
  },
  setName(state, name) {
    state.name = name;
  },
  // BEGIN::Added.by.KWShin.2023.10.26.
  setRole(state, role) {
    state.role = role;
  },
  // FINISH::Added.by.KWShin.2023.10.26.
  setAlertConfirmTime(state, alertConfirmTime) {
    state.alertConfirmTime = alertConfirmTime;
  },
  setHasJavaStack(state, hasJavaStack) {
    state.hasJavaStack = hasJavaStack;
  },
};

const actions = {
  async fetchUser({ commit }) {
    const { data } = await api.get('/user');
    Object.keys(data).forEach(name => commit(`set${pascalCase(name)}`, data[name]));
  },
  setLanguage({ commit }, language) {
    commit('setLanguage', language);
  },
  setTheme({ commit }, theme) {
    commit('setTheme', theme);
  },
  setAlertConfirmTime({ commit }, alertConfirmTime) {
    commit('setAlertConfirmTime', alertConfirmTime);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
